import { render, staticRenderFns } from "./MissingTagsWarning.vue?vue&type=template&id=93255f6a"
import script from "./MissingTagsWarning.vue?vue&type=script&lang=js"
export * from "./MissingTagsWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports